<div class="venta-container">
  <div class="left-panel">
    <mat-card class="search-card">
      <mat-card-header>
        <mat-card-title>Buscar Producto</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="busquedaForm">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Código o Nombre</mat-label>
            <input matInput formControlName="busqueda" placeholder="Escriba para buscar..."
                   (keyup.enter)="manejarTeclaBusqueda($event)">
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>

          <!-- Lista de sugerencias mejorada -->
          <mat-list *ngIf="mostrarSugerencias" class="sugerencias-list">
            <mat-list-item *ngIf="buscando">
              <mat-spinner diameter="24"></mat-spinner>
            </mat-list-item>
            <mat-list-item *ngFor="let producto of productosEncontrados"
                          [class.out-of-stock]="producto.stock <= 0"
                          (click)="agregarProductoDirecto(producto)">
              <span matLine>
                {{ producto.codigo }} - {{ producto.nombre }} - {{ producto.peso }}{{ producto.unidadMedida }}
              </span>
              <span matLine class="secondary-text">
                ${{ producto.precio | number }}
                <span *ngIf="producto.stock <= 0" class="stock-warning">(Sin stock)</span>
                <span *ngIf="producto.stock > 0" class="stock-info">(Disponible: {{producto.stock}})</span>
              </span>
            </mat-list-item>
            <mat-list-item *ngIf="!buscando && productosEncontrados.length === 0 && busquedaForm.get('busqueda')?.value.length >= 2">
              No se encontraron productos
            </mat-list-item>
          </mat-list>

          <div class="button-group">
            <button mat-raised-button color="primary" (click)="agregarProductoDirecto($event)" [disabled]="!productoForm.valid">
              <mat-icon>add_shopping_cart</mat-icon> Agregar
            </button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>

    <mat-card class="product-details-card">
      <mat-card-header>
        <mat-card-title>Detalles del Producto</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="productoForm">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="nombre" readonly>
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Cantidad disponible</mat-label>
            <input matInput type="number" formControlName="stock" readonly min="1" [max]="productoForm.get('stock')?.value">
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Precio</mat-label>
            <input matInput formControlName="precio" readonly>
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Modo de uso</mat-label>
            <input matInput formControlName="modoUso" readonly>
          </mat-form-field>
        </form>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="right-panel">
    <mat-card class="cart-card">
      <mat-card-header>
        <mat-card-title>Productos en Venta</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="cart-items">
          <table class="full-width">
            <thead>
              <tr>
                <th>Código</th>
                <th>Nombre</th>
                <th>Precio Unit.</th>
                <th>Cantidad</th>
                <th>Descuento</th>
                <th>Subtotal</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let producto of productosEnVenta; let i = index">
                <td>{{ producto.codigo }}</td>
                <td>{{ producto.nombre }}</td>
                <td>{{ producto.precio | currency }}</td>
                <td>
                  <div class="quantity-controls">
                    <button mat-icon-button (click)="actualizarCantidad(producto, producto.cantidad - 1)"
                            [disabled]="producto.cantidad <= 1">
                      <mat-icon>remove</mat-icon>
                    </button>
                    {{ producto.cantidad }}
                    <button mat-icon-button (click)="actualizarCantidad(producto, producto.cantidad + 1)"
                            [disabled]="producto.cantidad >= producto.stock">
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                </td>
                <td>
                  <mat-form-field appearance="outline" class="discount-field">
                    <input matInput type="number" 
                           [value]="producto.descuento || 0"
                           (blur)="actualizarDescuento(producto, $any($event.target).value)"
                           min="0"
                           [max]="producto.cantidad * producto.precio"
                           step="0.01"
                           placeholder="0.00">
                    <span matPrefix>$&nbsp;</span>
                  </mat-form-field>
                </td>
                <td>{{ producto.subtotal | currency }}</td>
                <td>
                  <button mat-icon-button color="warn" (click)="eliminarProducto(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <div *ngIf="productosEnVenta.length === 0" class="empty-cart">
            <mat-icon>shopping_cart</mat-icon>
            <p>No hay productos en la venta actual</p>
          </div>

          <!-- Resumen de compra -->
          <div class="payment-summary" *ngIf="productosEnVenta.length > 0">
            <div class="summary-row">
              <span>Subtotal:</span>
              <span>{{ calcularSubtotal() | currency }}</span>
            </div>
            <div class="summary-row" *ngIf="calcularTotalDescuentos() > 0">
              <span>Descuentos:</span>
              <span style="color: #f44336;">-{{ calcularTotalDescuentos() | currency }}</span>
            </div>
            <div class="summary-row">
              <span>IVA (16%):</span>
              <span>{{ 0 | currency }}</span>
            </div>
            <div class="summary-row total">
              <span>Total:</span>
              <span>{{ ventaForm.get('total')?.value | currency }}</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="payment-card">
      <mat-card-header>
        <mat-card-title>Finalizar Venta</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="processing-overlay" *ngIf="isLoading">
          <mat-spinner diameter="36"></mat-spinner>
          <span>Registrando venta...</span>
        </div>
        <form [formGroup]="ventaForm">
          <mat-checkbox formControlName="esApartado" (change)="calcularCambio()" class="full-width apartado-checkbox">
            <span class="apartado-label">
              <mat-icon>schedule</mat-icon>
              Esta venta es un apartado (pago parcial)
            </span>
          </mat-checkbox>

          <div class="apartado-info" *ngIf="ventaForm.get('esApartado')?.value">
            <mat-icon>info</mat-icon>
            <span>La venta quedará como pendiente hasta que se complete el pago</span>
          </div>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Dinero Recibido</mat-label>
            <input matInput type="number" formControlName="dineroRecibido" (input)="calcularCambio()" min="0">
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ ventaForm.get('esApartado')?.value ? 'Saldo Pendiente' : 'Cambio' }}</mat-label>
            <input matInput formControlName="cambio" readonly>
            <span matPrefix>$&nbsp;</span>
            <mat-hint *ngIf="ventaForm.get('esApartado')?.value && ventaForm.get('cambio')?.value < 0">
              Faltan {{ (ventaForm.get('cambio')?.value * -1) | currency }} por pagar
            </mat-hint>
          </mat-form-field>

          <div class="ticket-options" style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 16px;">
            <mat-checkbox [(ngModel)]="generarPdf" [ngModelOptions]="{standalone: true}" color="primary">
              Generar PDF (Ticket)
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="generarTicketImpresora" [ngModelOptions]="{standalone: true}" color="primary">
              Generar Ticket para Impresora (Texto)
            </mat-checkbox>
          </div>

          <button
            mat-raised-button
            color="primary"
            class="full-width generate-button"
            (click)="generarTicket()"
            [disabled]="!puedeGenerarTicket() || isLoading">
            <span class="generate-button-content">
              <mat-spinner *ngIf="isLoading" diameter="18"></mat-spinner>
              <mat-icon *ngIf="!isLoading">{{ ventaForm.get('esApartado')?.value ? 'schedule' : 'receipt' }}</mat-icon>
              <span>{{ isLoading ? 'Registrando...' : (ventaForm.get('esApartado')?.value ? 'Registrar Apartado' : 'Generar Ticket') }}</span>
            </span>
          </button>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
